'use client';

import { c as _c } from "react/compiler-runtime";
import { Slider } from '@base-ui/react/slider';
import { DirectionProvider } from '@base-ui/react/direction-provider';
import { useLocale } from 'next-intl';
type Props = {
  min: number;
  max: number;
  step?: number;
  /** Two-element [min, max] range. */
  value: [number, number];
  /** Live updates while dragging. */
  onChange?: (value: [number, number]) => void;
  /** Final value after the user releases. */
  onCommit?: (value: [number, number]) => void;
  ariaLabelStart?: string;
  ariaLabelEnd?: string;
};
export function RangeSlider(t0) {
  const $ = _c(23);
  const {
    min,
    max,
    step: t1,
    value,
    onChange,
    onCommit,
    ariaLabelStart,
    ariaLabelEnd
  } = t0;
  const step = t1 === undefined ? 1 : t1;
  const locale = useLocale();
  const direction = locale === "ar" ? "rtl" : "ltr";
  let t2;
  if ($[0] !== onChange) {
    t2 = v => {
      if (Array.isArray(v) && v.length === 2) {
        onChange?.([v[0], v[1]] as [number, number]);
      }
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onCommit) {
    t3 = v_0 => {
      if (Array.isArray(v_0) && v_0.length === 2) {
        onCommit?.([v_0[0], v_0[1]] as [number, number]);
      }
    };
    $[2] = onCommit;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Slider.Track className="h-1 w-full rounded-full bg-border"><Slider.Indicator className="block h-full rounded-full bg-primary" /></Slider.Track>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== ariaLabelStart) {
    t5 = <Slider.Thumb index={0} aria-label={ariaLabelStart} className="h-4 w-4 -ms-2 rounded-full border-2 border-primary bg-background shadow-sm transition-transform duration-100 hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-1" />;
    $[5] = ariaLabelStart;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== ariaLabelEnd) {
    t6 = <Slider.Thumb index={1} aria-label={ariaLabelEnd} className="h-4 w-4 -ms-2 rounded-full border-2 border-primary bg-background shadow-sm transition-transform duration-100 hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-1" />;
    $[7] = ariaLabelEnd;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <Slider.Control className="relative flex h-7 w-full cursor-pointer items-center">{t4}{t5}{t6}</Slider.Control>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== max || $[13] !== min || $[14] !== step || $[15] !== t2 || $[16] !== t3 || $[17] !== t7 || $[18] !== value) {
    t8 = <Slider.Root min={min} max={max} step={step} value={value} onValueChange={t2} onValueCommitted={t3} className="relative flex w-full select-none items-center px-2">{t7}</Slider.Root>;
    $[12] = max;
    $[13] = min;
    $[14] = step;
    $[15] = t2;
    $[16] = t3;
    $[17] = t7;
    $[18] = value;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== direction || $[21] !== t8) {
    t9 = <DirectionProvider direction={direction}>{t8}</DirectionProvider>;
    $[20] = direction;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}